import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { ProductTagsComponent } from '../../app/content/layout/components/product/product-tags/product-tags.component';
import { ProductTag } from '../../app/core/interfaces/generated/graphql';

const organicTag: ProductTag = { __typename: 'ProductTag', text: 'Økologisk', icon: '/assets/images/organic-icon.svg', color: '#4CAF50', altText: 'Økologisk vin' };
const veganTag: ProductTag = { __typename: 'ProductTag', text: 'Vegansk', icon: '/assets/images/vegan-icon.svg', color: '#2196F3', altText: 'Vegansk vin' };
const biodynamicTag: ProductTag = { __typename: 'ProductTag', text: 'Biodynamisk', icon: '/assets/images/biodynamic-icon.svg', color: '#FF9800', altText: 'Biodynamisk vin' };
const countryTag: ProductTag = { __typename: 'ProductTag', text: 'Frankrig', icon: '/assets/country_icons/fr_round.svg', color: '', altText: 'Frankrig', type: 'country' };

const meta: Meta<ProductTagsComponent> = {
  title: 'Atoms/Product Tags',
  component: ProductTagsComponent,
  parameters: {
    layout: 'centered',
    docs: {
      description: {
        component: 'Displays product tags (organic, vegan, country of origin, etc.) as icon badges with tooltips.',
      },
    },
  },
  argTypes: {
    hideCountry: { control: 'boolean', description: 'Hide country flag tag' },
  },
};

export default meta;
type Story = StoryObj<ProductTagsComponent>;

export const SingleTag: Story = {
  args: {
    tags: [organicTag],
    hideCountry: false,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Økologisk')).toBeInTheDocument();
  },
};

export const MultipleTags: Story = {
  args: {
    tags: [organicTag, veganTag, biodynamicTag],
    hideCountry: false,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Økologisk')).toBeInTheDocument();
    await expect(canvas.getByText('Vegansk')).toBeInTheDocument();
    await expect(canvas.getByText('Biodynamisk')).toBeInTheDocument();
  },
};

export const WithCountryFlag: Story = {
  args: {
    tags: [organicTag, countryTag],
    hideCountry: false,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Økologisk')).toBeInTheDocument();
    await expect(canvas.getByText('Frankrig')).toBeInTheDocument();
  },
};

export const CountryHidden: Story = {
  args: {
    tags: [organicTag, countryTag],
    hideCountry: true,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Økologisk')).toBeInTheDocument();
  },
};

export const NoTags: Story = {
  args: {
    tags: [],
    hideCountry: false,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.tag')).toBeFalsy();
  },
};
